const ptBR = {
  metaTitle: 'E-commerce Profissional | WSJ Soluções Digitais',
  badge: 'E-commerce',
  heroTitle: 'Venda online com uma loja virtual profissional.',
  heroSubtitle:
    'Criamos e-commerces modernos, seguros e preparados para transformar visitantes em clientes.',
  heroBadges: [
    'WooCommerce',
    'Shopify',
    'Pagamentos online',
    'Catálogo de produtos',
    'Checkout seguro',
    'WhatsApp integrado',
    'SEO',
    'Mobile first'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnProjects: 'Ver projetos',
  whatsappMessage: 'Olá! Gostaria de um orçamento para e-commerce com a WSJ.',

  sectionProblemsTitle: 'O que impede muitas lojas de vender mais?',
  sectionProblemsClose:
    'A WSJ estrutura sua loja para vender com clareza, velocidade e confiança.',
  problemItems: [
    { title: 'Loja lenta', desc: 'Cada segundo a mais no carregamento reduz conversões e aumenta abandono.' },
    { title: 'Checkout confuso', desc: 'Processos longos ou pouco claros fazem o cliente desistir no último passo.' },
    { title: 'Catálogo desorganizado', desc: 'Produtos mal categorizados dificultam a navegação e a compra.' },
    { title: 'Falta de confiança', desc: 'Visual amador, informações incompletas e ausência de segurança afastam compradores.' },
    { title: 'Pouca presença no Google', desc: 'Sem SEO estruturado, sua loja perde visibilidade orgânica.' },
    { title: 'Dificuldade para gerir pedidos', desc: 'Operação desorganizada gera retrabalho, atrasos e insatisfação.' }
  ],

  sectionPlatformsTitle: 'Tecnologia certa para cada tipo de loja',
  sectionPlatformsLead: 'Escolhemos a plataforma ideal conforme objetivo, operação e nível de personalização.',
  platformWooTitle: 'WordPress + WooCommerce',
  platformWooDesc:
    'Uma solução flexível para lojas que precisam de controle, personalização e boa relação custo-benefício.',
  platformWooIdealLabel: 'Ideal para:',
  platformWooIdeal: [
    'Pequenas e médias lojas',
    'Catálogo personalizado',
    'Blog e SEO',
    'Controle maior da estrutura',
    'Integrações específicas'
  ],
  platformShopifyTitle: 'Shopify',
  platformShopifyDesc:
    'Uma plataforma robusta para empresas que querem vender com estabilidade, escala e operação simplificada.',
  platformShopifyIdealLabel: 'Ideal para:',
  platformShopifyIdeal: [
    'Lojas com foco em vendas rápidas',
    'Gestão simplificada',
    'Escalabilidade',
    'Checkout otimizado',
    'Operação profissional'
  ],
  platformsNote:
    'A escolha da plataforma depende do objetivo, orçamento, operação e nível de personalização do negócio.',

  sectionDeliverablesTitle: 'Uma loja virtual completa para vender com profissionalismo',
  sectionDeliverablesLead: 'Do design à operação — tudo estruturado para vender online com segurança.',
  deliverables: [
    { title: 'Design premium', desc: 'Visual profissional que transmite confiança desde o primeiro clique.' },
    { title: 'Cadastro de produtos', desc: 'Catálogo organizado com informações claras para o cliente.' },
    { title: 'Categorias organizadas', desc: 'Navegação intuitiva para encontrar produtos com facilidade.' },
    { title: 'Checkout configurado', desc: 'Fluxo de compra objetivo, seguro e preparado para conversão.' },
    { title: 'Meios de pagamento', desc: 'Integração com opções de pagamento online confiáveis.' },
    { title: 'Integração com WhatsApp', desc: 'Atendimento e vendas por canal que seus clientes já usam.' },
    { title: 'SEO técnico', desc: 'Base otimizada para indexação e visibilidade no Google.' },
    { title: 'Performance otimizada', desc: 'Loja rápida no celular e no desktop.' },
    { title: 'Responsivo', desc: 'Experiência perfeita em qualquer dispositivo.' },
    { title: 'Segurança SSL', desc: 'Conexão criptografada para proteger dados e transmitir confiança.' },
    { title: 'Painel administrativo', desc: 'Gestão de produtos, pedidos e conteúdo de forma organizada.' },
    { title: 'Treinamento básico', desc: 'Orientação para você operar a loja com autonomia após a entrega.' }
  ],

  sectionProcessTitle: 'Como funciona o processo',
  sectionProcessLead: 'Um caminho claro da estratégia à publicação — com acompanhamento em cada etapa.',
  processSteps: [
    { title: 'Entendemos seu negócio', desc: 'Mapeamos produtos, público, operação e objetivos de venda.' },
    { title: 'Definimos a melhor plataforma', desc: 'WooCommerce ou Shopify — conforme escopo, orçamento e crescimento.' },
    { title: 'Construímos sua loja', desc: 'Design, catálogo, checkout, integrações e configurações técnicas.' },
    { title: 'Publicamos e acompanhamos', desc: 'Go-live, testes finais e suporte para você vender com confiança.' }
  ],

  sectionPlansTitle: 'Planos para vender online com estrutura profissional',
  sectionPlansLead: 'Loja virtual, suporte e tecnologia para escalar suas vendas digitais.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansDisclaimer:
    'Projetos com integrações avançadas, gateways específicos, ERP, automações, multi-idioma ou regras de negócio podem exigir análise técnica e orçamento personalizado.',
  planStartName: 'E-commerce Start',
  planStartDesc: 'Ideal para quem quer começar a vender online com uma loja profissional.',
  planStartFeatures: [
    'Loja virtual profissional',
    'Até 30 produtos',
    'Categorias organizadas',
    'Design responsivo',
    'Integração com WhatsApp',
    'Checkout configurado',
    'SEO básico',
    'SSL seguro',
    'Hospedagem inclusa quando aplicável',
    'Suporte por email'
  ],
  planStartCta: 'Começar loja',
  planGrowthName: 'E-commerce Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para lojas que querem crescer com mais estrutura, performance e recursos.',
  planGrowthFeatures: [
    'Tudo do Start',
    'Até 100 produtos',
    'SEO avançado',
    'Blog',
    'Performance otimizada',
    'Google Analytics',
    'Google Search Console',
    'Integrações com ferramentas externas',
    'Formulários premium',
    'Suporte prioritário',
    'Treinamento básico'
  ],
  planGrowthCta: 'Começar agora',
  planPremiumName: 'E-commerce Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal para empresas que precisam de uma operação de vendas online mais completa e personalizada.',
  planPremiumFeatures: [
    'Loja completa personalizada',
    'Produtos ilimitados',
    'Automação de processos',
    'Integrações avançadas',
    'Relatórios e dashboards',
    'Multi-idioma quando necessário',
    'Consultoria estratégica',
    'Suporte prioritário',
    'Atendimento dedicado',
    'Orçamento técnico personalizado'
  ],
  planPremiumCta: 'Falar com especialista',

  sectionRealProjectsTitle: 'Projetos reais com presença digital construída pela WSJ',
  sectionRealProjectsLead: 'Algumas empresas que confiaram na WSJ para fortalecer sua operação online.',
  realProjectsVisitCta: 'Visitar site',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Loja virtual desenvolvida com foco em catálogo, experiência do usuário e vendas online.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'E-commerce moderno com foco em navegação intuitiva, identidade visual e presença digital.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Site Institucional',
      badge: 'institutional',
      desc: 'Site institucional usado como exemplo de presença digital profissional para empresas.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de investir na sua loja virtual.',
  faqItems: [
    {
      q: 'Qual plataforma é melhor: WooCommerce ou Shopify?',
      a: 'Depende do seu negócio. WooCommerce oferece mais flexibilidade e controle; Shopify prioriza operação simplificada e escala. A WSJ indica a melhor opção após entender seu objetivo, orçamento e operação.'
    },
    {
      q: 'Vocês cadastram os produtos?',
      a: 'Sim. Podemos estruturar e cadastrar produtos conforme o plano contratado, com categorias, descrições e imagens organizadas.'
    },
    {
      q: 'A loja aceita pagamentos online?',
      a: 'Sim. Configuramos meios de pagamento online conforme a plataforma escolhida e as necessidades do seu negócio.'
    },
    {
      q: 'Posso vender pelo WhatsApp também?',
      a: 'Sim. Integramos WhatsApp para atendimento, dúvidas e apoio às vendas — canal essencial no mercado brasileiro.'
    },
    {
      q: 'A loja aparece no Google?',
      a: 'Implementamos SEO técnico e estrutural desde a base. Resultados orgânicos também dependem de conteúdo e estratégia contínua.'
    },
    {
      q: 'Vocês oferecem suporte após a entrega?',
      a: 'Sim. Cada plano inclui suporte conforme o nível contratado, além de orientação para operação da loja.'
    },
    {
      q: 'Posso começar pequeno e evoluir depois?',
      a: 'Sim. Nossos planos permitem começar com estrutura profissional e evoluir conforme suas vendas crescem.'
    }
  ],

  finalCtaTitle: 'Pronto para vender online com uma loja profissional?',
  finalCtaSubtitle:
    'A WSJ cria a estrutura digital para sua empresa vender com mais confiança, velocidade e organização.',

  heroMock: {
    storeLabel: 'Loja virtual',
    cartLabel: 'Carrinho',
    checkoutLabel: 'Checkout seguro',
    featuredLabel: 'Destaque',
    salesLabel: 'Vendas',
    ordersLabel: 'Pedidos',
    metric: '+84%',
    live: 'Ao vivo'
  }
};

const ptPT = {
  ...ptBR,
  heroSubtitle:
    'Criamos e-commerces modernos, seguros e preparados para transformar visitantes em clientes.',
  sectionProblemsClose:
    'A WSJ estrutura a sua loja online para vender com clareza, velocidade e confiança.',
  problemItems: [
    { title: 'Loja lenta', desc: 'Cada segundo a mais no carregamento reduz conversões e aumenta abandono.' },
    { title: 'Checkout confuso', desc: 'Processos longos ou pouco claros fazem o cliente desistir no último passo.' },
    { title: 'Catálogo desorganizado', desc: 'Produtos mal categorizados dificultam a navegação e a compra.' },
    { title: 'Falta de confiança', desc: 'Visual amador, informações incompletas e ausência de segurança afastam compradores.' },
    { title: 'Pouca presença no Google', desc: 'Sem SEO estruturado, a sua loja perde visibilidade orgânica.' },
    { title: 'Dificuldade para gerir pedidos', desc: 'Operação desorganizada gera retrabalho, atrasos e insatisfação.' }
  ],
  sectionDeliverablesTitle: 'Uma loja online completa para vender com profissionalismo',
  sectionDeliverablesLead: 'Do design à operação — tudo estruturado para vender online com segurança.',
  planStartFeatures: [
    'Loja online profissional',
    'Até 30 produtos',
    'Categorias organizadas',
    'Design responsivo',
    'Integração com WhatsApp',
    'Checkout configurado',
    'SEO básico',
    'SSL seguro',
    'Alojamento incluso quando aplicável',
    'Suporte por email'
  ],
  realProjects: [
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Loja online desenvolvida com foco em catálogo, experiência do utilizador e vendas digitais.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'E-commerce moderno com foco em navegação intuitiva, identidade visual e presença digital.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Site Institucional',
      badge: 'institutional',
      desc: 'Site institucional usado como exemplo de presença digital profissional para empresas.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    }
  ],
  faqItems: [
    {
      q: 'Qual plataforma é melhor: WooCommerce ou Shopify?',
      a: 'Depende do seu negócio. WooCommerce oferece mais flexibilidade e controlo; Shopify prioriza operação simplificada e escala. A WSJ indica a melhor opção após entender o seu objetivo, orçamento e operação.'
    },
    {
      q: 'Cadastram os produtos?',
      a: 'Sim. Podemos estruturar e cadastrar produtos conforme o plano contratado, com categorias, descrições e imagens organizadas.'
    },
    {
      q: 'A loja aceita pagamentos online?',
      a: 'Sim. Configuramos meios de pagamento online conforme a plataforma escolhida e as necessidades do seu negócio.'
    },
    {
      q: 'Posso vender pelo WhatsApp também?',
      a: 'Sim. Integramos WhatsApp para atendimento, dúvidas e apoio às vendas.'
    },
    {
      q: 'A loja aparece no Google?',
      a: 'Implementamos SEO técnico e estrutural desde a base. Resultados orgânicos também dependem de conteúdo e estratégia contínua.'
    },
    {
      q: 'Oferecem suporte após a entrega?',
      a: 'Sim. Cada plano inclui suporte conforme o nível contratado, além de orientação para operação da loja.'
    },
    {
      q: 'Posso começar pequeno e evoluir depois?',
      a: 'Sim. Os nossos planos permitem começar com estrutura profissional e evoluir conforme as vendas crescem.'
    }
  ],
  finalCtaSubtitle:
    'A WSJ cria a estrutura digital para a sua empresa vender com mais confiança, velocidade e organização.'
};

const enUS = {
  metaTitle: 'Professional E-commerce | WSJ Soluções Digitais',
  badge: 'E-commerce',
  heroTitle: 'Sell online with a professional online store.',
  heroSubtitle:
    'We build modern, secure e-commerce stores designed to turn visitors into customers.',
  heroBadges: [
    'WooCommerce',
    'Shopify',
    'Online payments',
    'Product catalogue',
    'Secure checkout',
    'WhatsApp integrated',
    'SEO',
    'Mobile first'
  ],
  btnQuote: 'Request a quote',
  btnWhatsapp: 'Talk on WhatsApp',
  btnProjects: 'View projects',
  whatsappMessage: 'Hello! I would like a quote for e-commerce with WSJ.',

  sectionProblemsTitle: 'What stops many stores from selling more?',
  sectionProblemsClose: 'WSJ structures your store to sell with clarity, speed and trust.',
  problemItems: [
    { title: 'Slow store', desc: 'Every extra second of loading reduces conversions and increases abandonment.' },
    { title: 'Confusing checkout', desc: 'Long or unclear processes make customers quit at the last step.' },
    { title: 'Disorganised catalogue', desc: 'Poorly categorised products make browsing and buying harder.' },
    { title: 'Lack of trust', desc: 'Amateur visuals, incomplete information and missing security drive buyers away.' },
    { title: 'Low Google visibility', desc: 'Without structured SEO, your store loses organic reach.' },
    { title: 'Order management chaos', desc: 'Disorganised operations cause rework, delays and dissatisfaction.' }
  ],

  sectionPlatformsTitle: 'The right technology for each store type',
  sectionPlatformsLead: 'We choose the ideal platform based on goals, operations and customisation needs.',
  platformWooTitle: 'WordPress + WooCommerce',
  platformWooDesc:
    'A flexible solution for stores that need control, customisation and strong value for money.',
  platformWooIdealLabel: 'Ideal for:',
  platformWooIdeal: [
    'Small and medium stores',
    'Custom catalogue',
    'Blog and SEO',
    'Greater structural control',
    'Specific integrations'
  ],
  platformShopifyTitle: 'Shopify',
  platformShopifyDesc:
    'A robust platform for businesses that want to sell with stability, scale and simplified operations.',
  platformShopifyIdealLabel: 'Ideal for:',
  platformShopifyIdeal: [
    'Sales-focused stores',
    'Simplified management',
    'Scalability',
    'Optimised checkout',
    'Professional operations'
  ],
  platformsNote:
    'Platform choice depends on business goals, budget, operations and customisation level.',

  sectionDeliverablesTitle: 'A complete online store to sell professionally',
  sectionDeliverablesLead: 'From design to operations — everything structured for secure online sales.',
  deliverables: [
    { title: 'Premium design', desc: 'Professional visuals that build trust from the first click.' },
    { title: 'Product setup', desc: 'Organised catalogue with clear information for customers.' },
    { title: 'Organised categories', desc: 'Intuitive navigation to find products easily.' },
    { title: 'Configured checkout', desc: 'Clear, secure purchase flow built for conversion.' },
    { title: 'Payment methods', desc: 'Integration with trusted online payment options.' },
    { title: 'WhatsApp integration', desc: 'Support and sales through a channel customers already use.' },
    { title: 'Technical SEO', desc: 'Optimised foundation for indexing and Google visibility.' },
    { title: 'Optimised performance', desc: 'Fast store on mobile and desktop.' },
    { title: 'Responsive', desc: 'Perfect experience on any device.' },
    { title: 'SSL security', desc: 'Encrypted connection to protect data and build trust.' },
    { title: 'Admin dashboard', desc: 'Organised management of products, orders and content.' },
    { title: 'Basic training', desc: 'Guidance so you can operate the store independently after launch.' }
  ],

  sectionProcessTitle: 'How the process works',
  sectionProcessLead: 'A clear path from strategy to launch — with follow-up at every stage.',
  processSteps: [
    { title: 'We understand your business', desc: 'We map products, audience, operations and sales goals.' },
    { title: 'We define the best platform', desc: 'WooCommerce or Shopify — based on scope, budget and growth.' },
    { title: 'We build your store', desc: 'Design, catalogue, checkout, integrations and technical setup.' },
    { title: 'We launch and support', desc: 'Go-live, final testing and support so you sell with confidence.' }
  ],

  sectionPlansTitle: 'Plans to sell online with professional structure',
  sectionPlansLead: 'Online store, support and technology to scale your digital sales.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansDisclaimer:
    'Projects with advanced integrations, specific gateways, ERP, automations, multi-language or business rules may require technical analysis and a custom quote.',
  planStartName: 'E-commerce Start',
  planStartDesc: 'Ideal for businesses starting to sell online with a professional store.',
  planStartFeatures: [
    'Professional online store',
    'Up to 30 products',
    'Organised categories',
    'Responsive design',
    'WhatsApp integration',
    'Configured checkout',
    'Basic SEO',
    'Secure SSL',
    'Hosting included when applicable',
    'Email support'
  ],
  planStartCta: 'Start store',
  planGrowthName: 'E-commerce Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for stores that want to grow with more structure, performance and features.',
  planGrowthFeatures: [
    'Everything in Start',
    'Up to 100 products',
    'Advanced SEO',
    'Blog',
    'Optimised performance',
    'Google Analytics',
    'Google Search Console',
    'External tool integrations',
    'Premium forms',
    'Priority support',
    'Basic training'
  ],
  planGrowthCta: 'Get started',
  planPremiumName: 'E-commerce Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal for businesses that need a more complete and tailored online sales operation.',
  planPremiumFeatures: [
    'Fully customised store',
    'Unlimited products',
    'Process automation',
    'Advanced integrations',
    'Reports and dashboards',
    'Multi-language when needed',
    'Strategic consulting',
    'Priority support',
    'Dedicated account manager',
    'Custom technical quote'
  ],
  planPremiumCta: 'Talk to a specialist',

  sectionRealProjectsTitle: 'Real projects with digital presence built by WSJ',
  sectionRealProjectsLead: 'Some companies that trusted WSJ to strengthen their online operation.',
  realProjectsVisitCta: 'Visit website',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjects: [
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Online store focused on catalogue, user experience and digital sales.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'E-commerce',
      badge: 'ecommerce',
      desc: 'Modern e-commerce focused on intuitive navigation, visual identity and digital presence.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Corporate Website',
      badge: 'institutional',
      desc: 'Corporate website showcasing professional digital presence for businesses.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you invest in your online store.',
  faqItems: [
    {
      q: 'Which platform is better: WooCommerce or Shopify?',
      a: 'It depends on your business. WooCommerce offers more flexibility and control; Shopify prioritises simplified operations and scale. WSJ recommends the best option after understanding your goals, budget and operations.'
    },
    {
      q: 'Do you set up the products?',
      a: 'Yes. We can structure and upload products according to your plan, with organised categories, descriptions and images.'
    },
    {
      q: 'Does the store accept online payments?',
      a: 'Yes. We configure online payment methods based on the chosen platform and your business needs.'
    },
    {
      q: 'Can I also sell via WhatsApp?',
      a: 'Yes. We integrate WhatsApp for support, questions and sales assistance.'
    },
    {
      q: 'Will the store appear on Google?',
      a: 'We implement technical and structural SEO from the ground up. Organic results also depend on content and ongoing strategy.'
    },
    {
      q: 'Do you offer support after delivery?',
      a: 'Yes. Each plan includes support according to the contracted level, plus guidance for store operations.'
    },
    {
      q: 'Can I start small and grow later?',
      a: 'Yes. Our plans let you start with professional structure and evolve as sales grow.'
    }
  ],

  finalCtaTitle: 'Ready to sell online with a professional store?',
  finalCtaSubtitle:
    'WSJ builds the digital structure for your business to sell with more confidence, speed and organisation.',

  heroMock: {
    storeLabel: 'Online store',
    cartLabel: 'Cart',
    checkoutLabel: 'Secure checkout',
    featuredLabel: 'Featured',
    salesLabel: 'Sales',
    ordersLabel: 'Orders',
    metric: '+84%',
    live: 'Live'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const ecommercePageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
